import React from 'react';
import { Modal, Image } from 'react-bootstrap';

function ImageModal({ show, onHide, selectedImage }) {
  return (
    <Modal 
      show={show} 
      onHide={onHide}
      size="xl"
      centered
    >
      <Modal.Body className="p-0">
        <Image
          src={selectedImage ? `photos/${selectedImage}` : ''}
          alt=""
          className="w-100"
          style={{ maxHeight: '90vh', objectFit: 'contain' }}
        />
      </Modal.Body>
      <button
        className="btn-close position-absolute top-0 end-0 m-2 bg-white"
        onClick={onHide}
        aria-label="Close"
      />
    </Modal>
  );
}

export default ImageModal;